// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".frame-area[data-v-f3cef792]{display:block;width:150%;max-width:200%!important;height:700px;overflow:auto;border:1px solid #999;margin:0;padding:0;overflow-x:scroll!important;-webkit-overflow-scrolling:touch}", ""]);
// Exports
module.exports = exports;
